import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { datetime } from '@bringg/types';
import { action, computed, observable, makeObservable } from 'mobx';

export default class TagMerchantConfiguration {
	id: number;
	merchant_id: number;
	tag_id: number;
	sharing_mode = 0;
	created_at?: datetime;
	updated_at?: datetime;
	send_shared_location_webhook_on_contacts_missing = false;

	constructor(config: Partial<Bringg.TagCustomerConfiguration>) {
		makeObservable(this, {
			sharing_mode: observable,
			send_shared_location_webhook_on_contacts_missing: observable,
			updateSharingMode: action,
			updateSendSharedLocationWebhookOnContactsMissing: action,
			sharingMode: computed,
			sendSharedLocationWebhookOnContactsMissing: computed
		});

		Object.assign(this, config);
	}

	updateSharingMode = (mode: number) => {
		this.sharing_mode = mode;
	};

	updateSendSharedLocationWebhookOnContactsMissing = (value: boolean) => {
		this.send_shared_location_webhook_on_contacts_missing = value;
	};

	get sharingMode(): number {
		return this.sharing_mode;
	}

	get sendSharedLocationWebhookOnContactsMissing(): boolean {
		return this.send_shared_location_webhook_on_contacts_missing;
	}

	async upsert(): Promise<Bringg.TagMerchantConfiguration> {
		let response;
		if (this.id) {
			response = await getRootEnv().dashboardSdk.sdk.tagMerchantConfigurations.update(this.id, this);
		} else {
			response = await getRootEnv().dashboardSdk.sdk.tagMerchantConfigurations.create(this.tag_id, this);
		}
		return response.tag_merchant_configuration;
	}
}
